const config = {
  aws_project_region: 'ap-south-1',
  aws_cognito_identity_pool_id:
    'ap-south-1:3c3b4dfb-4565-4d4f-96c5-1f5bfcfe4ce6',
  aws_cognito_region: 'ap-south-1',
  aws_user_pools_id: 'ap-south-1_FSWr7zMhO',
  aws_user_pools_web_client_id: '605rpm3gpo95j288tnqvhbsbd',
  oauth: {
    domain: 'engage-auth.auth.ap-south-1.amazoncognito.com',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'http://localhost:8000/',
    redirectSignOut: 'http://localhost:8000/',
    responseType: 'code',
  },
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

export default config;
